import { FormattedVerificationServiceConfiguration } from "@idw-types/data/verification-service-configuration";

export enum VerificationServicesActionTypes {
    // Services
    SET_VERIFICATION_SERVICE_CONFIGURATIONS_LOADING = "SET_VERIFICATION_SERVICE_CONFIGURATIONS_LOADING",
    SET_VERIFICATION_SERVICE_CONFIGURATIONS = "SET_VERIFICATION_SERVICE_CONFIGURATIONS",
    REPLACE_VERIFICATION_SERVICE_CONFIGURATION = "REPLACE_VERIFICATION_SERVICE_CONFIGURATION",
    REMOVE_VERIFICATION_SERVICE_CONFIGURATION = "REMOVE_VERIFICATION_SERVICE_CONFIGURATION"
}

// Services
type SetVerificationServiceConfigurationsLoadingAction = {
    type: VerificationServicesActionTypes.SET_VERIFICATION_SERVICE_CONFIGURATIONS_LOADING,
    payload: { isLoading: boolean; }
};

export const setVerificationServiceConfigurationsLoading = (
    isLoading: boolean
): SetVerificationServiceConfigurationsLoadingAction => ({
    type: VerificationServicesActionTypes.SET_VERIFICATION_SERVICE_CONFIGURATIONS_LOADING,
    payload: { isLoading }
});

type SetVerificationServiceConfigurationsAction = {
    type: VerificationServicesActionTypes.SET_VERIFICATION_SERVICE_CONFIGURATIONS,
    payload: { verificationServiceConfigurations: Array<FormattedVerificationServiceConfiguration>; }
};

export const setVerificationServiceConfigurations = (
    verificationServiceConfigurations: Array<FormattedVerificationServiceConfiguration>
): SetVerificationServiceConfigurationsAction => ({
    type: VerificationServicesActionTypes.SET_VERIFICATION_SERVICE_CONFIGURATIONS,
    payload: { verificationServiceConfigurations }
});

type ReplaceVerificationServiceConfigurationAction = {
    type: VerificationServicesActionTypes.REPLACE_VERIFICATION_SERVICE_CONFIGURATION;
    payload: { verificationServiceConfiguration: FormattedVerificationServiceConfiguration };
};

export const replaceVerificationServiceConfiguration = (
    verificationServiceConfiguration: FormattedVerificationServiceConfiguration
): ReplaceVerificationServiceConfigurationAction => ({
    type: VerificationServicesActionTypes.REPLACE_VERIFICATION_SERVICE_CONFIGURATION,
    payload: { verificationServiceConfiguration }
});

type RemoveVerificationServiceConfigurationAction = {
    type: VerificationServicesActionTypes.REMOVE_VERIFICATION_SERVICE_CONFIGURATION;
    payload: { verificationServiceConfiguration: FormattedVerificationServiceConfiguration };
};

export const removeVerificationServiceConfiguration = (
    verificationServiceConfiguration: FormattedVerificationServiceConfiguration
): RemoveVerificationServiceConfigurationAction => ({
    type: VerificationServicesActionTypes.REMOVE_VERIFICATION_SERVICE_CONFIGURATION,
    payload: { verificationServiceConfiguration }
});

export type VerificationServicesActions =
    // Services
    SetVerificationServiceConfigurationsLoadingAction |
    SetVerificationServiceConfigurationsAction |
    ReplaceVerificationServiceConfigurationAction |
    RemoveVerificationServiceConfigurationAction